import HCEGeneric from "./HCEGeneric";
export default HCEGeneric;